import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import React from 'react';
import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import SecondaryRaisedButton from '../buttons/SecondaryRaisedButton';
import Text from '../common/Text';
import Translatable from '../common/Translatable';
import Heading from '../heading/Heading';
import Icon from '../Icon';
import { media } from '../styles/breakpoints';

defineMessages({
    couponTitle: {
        id: 'COUPON_BAR_TITLE',
        defaultMessage: 'Gutschein Express',
    },
    couponText: {
        id: 'COUPON_BAR_TEXT',
        defaultMessage: 'Du brauchst aber etwas sofort? Gutschein samt Farbkarte ganz fix in Deinen Briefkasten.',
    },
    couponValueLabel: {
        id: 'COUPON_VALUE_INPUT_LABEL',
        defaultMessage: 'Betrag wählen.',
    },
    couponValueHelp: {
        id: 'COUPON_VALUE_INPUT_HELP',
        defaultMessage: 'In 25€ Schritten. Mindestens 25€.',
    },
    vatAndShippingShort: {
        id: 'VAT_SHIPPING_INCL_SHORT',
        defaultMessage: 'inkl. USt. & Versand',
    },
});


class CouponBar extends React.Component {

    state = {
        value: 25,
    };

    handleChange = event => {
        this.setState({ value: event.target.value });
    };

    render() {
        const StyledBar = styled.div`
        &.stolo-newsletter-bar {
            background-color: ${props => props.theme.palette.secondary.A400};
            margin: ${props => props.theme.space[12]} 0;
            padding: ${props => props.theme.space[6]} 
                     ${props => props.theme.space[10]}
                     ${props => props.theme.space[9]}
                     ${props => props.theme.space[10]};
            display: flex;
            align-items: stretch;
            justify-content: center;
         ${media.tweak1600up`
          margin: ${props => props.theme.space[12]} 0;
        `}
        ${media.wideScreenUp`
          margin: ${props => props.theme.space[12]} 0;
        `}
        ${media.normalPortraitUp`
          flex-direction: column;
          justify-content: center;
        `}
        }
    `;

        const StyledInputWrapper = styled.form`
            display: flex;
            justify-content: center;
            align-items: flex-end;
            
            ${media.normalPortraitUp`
                justify-content: center;
            `}
        `;

        const StyledSelectWrapper = styled.div`
            display: flex;
            flex-direction: column;
            & .stolo-select {
                margin: ${props => props.theme.space[7]} ${
            props => props.theme.space[5]} ${props => props.theme.space[3]} 0;
                background-color: ${props => props.theme.palette.secondary.A200};
                padding: 2px;
                color: ${props => props.theme.palette.primary.dark};
                display: inline-flex;
                position: relative;
                font-size: 1rem;
                line-height: 1.1875em;
                max-height: 2em;
               
            }
            & .stolo-select-native {
                padding: 0;
            }
            & .stolo-coupon {
                color: rgba(0, 0, 0, 0.87);
                display: inline-flex;
                position: relative;
                font-size: 1rem;
                line-height: 1.1875em;
                border: 0;
                outline: none;
                width: 100%;
            }
            & .stolo-coupon::before {
                left: 0;
                right: 0;
                bottom: 0;
                height: 1px;
                content: "";
                position: absolute;
                transition: background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                pointer-events: none;
                background-color: rgba(0, 0, 0, 0.42);
            }
        `;

        const StyledButtonWrapper = styled.div`
            display: flex;
            align-items: stretch;
            justify-content: flex-end;
            margin-left: ${props => props.theme.space[5]};
        `;

        const StyledText = styled.div`
            max-width: ${props => props.theme.space[24]};
            width: 60%;
            margin: auto;
            text-align: center;
            ${media.normalPortraitUp`
               text-align: center;
               width: inherit;
            `}   
            & h3{
               ${media.normalPortraitUp`
                   text-align: center;
                   width: inherit;
                `}
            };
        `;

        const StyledMessage = styled(Translatable)`
          margin-left: ${props => props.theme.space[5]};
        `;

        const StyledPriceSuffix = styled(Translatable)`
          font-size:  ${props => props.theme.fontSizes[6]};
          color: ${props => props.theme.palette.blueGrey[300]};
        `;

        return (
            <StyledBar className='stolo-newsletter-bar'>
                <Text>
                    <StyledText className='stolo-inner-text'>
                        <Heading
                            text={[
                                <Icon
                                    name={'icon-gift'} height='1.6rem'
                                    width='1.6rem' key='1' margin='0'
                                />, <StyledMessage
                                    message='COUPON_BAR_TITLE'
                                    key='2'
                                />]}
                            level={3}
                            center
                        />
                        <Translatable message='COUPON_BAR_TEXT' />
                    </StyledText>
                    <StyledInputWrapper
                        action='https://checkout.stoff.love/cart'
                        method='post'
                        acceptCharset='utf-8'
                    >
                        <StyledSelectWrapper>
                            <Select
                                native
                                value={this.state.value}
                                onChange={this.handleChange}
                                input={<Input
                                    id='stolo-coupon'
                                    classes={{ root: 'stolo-coupon' }}
                                />}
                                classes={{
                                    root: 'stolo-select',
                                    select: 'stolo-select-native',
                                }}
                            >
                                <option value={25}>25€</option>
                                <option value={50}>50€</option>
                                <option value={75}>75€</option>
                                <option value={100}>100€</option>
                            </Select>
                            <StyledPriceSuffix
                                message='VAT_SHIPPING_INCL_SHORT'
                            />
                        </StyledSelectWrapper>
                        <StyledButtonWrapper>
                            <SecondaryRaisedButton
                                type='submit'
                                value='add-to-cart'
                                disabled={false}
                                icon='shopping_cart'
                                height={'1em'}
                                text={<Translatable
                                    message='CART_BUTTON_LABEL'
                                />}
                            />
                        </StyledButtonWrapper>
                        <div>
                            <input
                                type='hidden' name='name'
                                value={`Gutschein ${this.state.value}€`}
                                key={'foxy1'}
                            />
                            <input
                                type='hidden' name='price'
                                value={(
                                    this.state.value / 1.19
                                ).toFixed(3)}
                                key={'foxy2'}
                            />
                            <input
                                type='hidden' name='category'
                                value='swatches'
                                key={'foxy3'}
                            />
                            <input
                                type='hidden' name='code'
                                value={`coupon-${this.state.value}`}
                                key={'foxy4'}
                            />
                        </div>
                    </StyledInputWrapper>
                </Text>
            </StyledBar>
        );
    }

}


export default CouponBar;



// WEBPACK FOOTER //
// ./src/components/home/CouponBar.js